import { render, staticRenderFns } from "./PopupContainer.vue?vue&type=template&id=25121cb0"
import script from "./PopupContainer.vue?vue&type=script&lang=js"
export * from "./PopupContainer.vue?vue&type=script&lang=js"
import style0 from "./PopupContainer.vue?vue&type=style&index=0&id=25121cb0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports